var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-input',_vm._b({attrs:{"value":_vm.formattedValue,"prefix":"$"},on:{"input":_vm.toCents}},'q-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }